import { supportTranslationCountryConvertMap } from '../constants/country';
import { JOVE_DEFAULT_LOCALE_COUNTRY, JOVE_LOCAL_LOCALE_COUNTRY_KEY } from '../hooks/useLocaleSwitch';
export var handleRequestConfig = function handleRequestConfig(config) {
  var _window, _supportTranslationCo;

  var _ref = ((_window = window) === null || _window === void 0 ? void 0 : _window.location) || {},
      hostname = _ref.hostname,
      port = _ref.port,
      pathname = _ref.pathname;

  var clientFrom = '';
  var isLocalHost = hostname === 'localhost';

  if (isLocalHost) {
    if (port === '4200') {
      clientFrom = 'cms';
    } else if (port === '4201') {
      clientFrom = 'validation';
    } else if (port === '4202') {
      clientFrom = 'dashboard';
    } else if (port === '4203') {
      clientFrom = 'website';
    } else {
      clientFrom = 'quote';
    }
  } else {
    if (hostname.includes('quote.')) {
      clientFrom = 'quote';
    } else if (hostname.includes('validation.')) {
      clientFrom = 'validation';
    } else if (hostname.includes('cms.')) {
      clientFrom = 'cms';
    } else if (hostname.includes('dashboard.')) {
      clientFrom = 'dashboard';
    } else {
      clientFrom = 'website';
    }
  } // Organazation manager


  if (clientFrom === 'cms' && pathname.includes('/organization/')) {
    clientFrom = 'manager';
  } // Multiple language


  var client_lng = ((_supportTranslationCo = supportTranslationCountryConvertMap[JOVE_DEFAULT_LOCALE_COUNTRY]) === null || _supportTranslationCo === void 0 ? void 0 : _supportTranslationCo.locale) || supportTranslationCountryConvertMap.DEFAULT.locale;

  try {
    if (localStorage.getItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY)) {
      var _supportTranslationCo2;

      client_lng = ((_supportTranslationCo2 = supportTranslationCountryConvertMap[localStorage.getItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY)]) === null || _supportTranslationCo2 === void 0 ? void 0 : _supportTranslationCo2.locale) || supportTranslationCountryConvertMap.DEFAULT.locale;
    }
  } catch (e) {}

  config.headers.client_from = clientFrom;
  config.headers.client_version = '1.0.0';
  config.headers.client_lng = client_lng;

  if (clientFrom === 'cms' && sessionStorage.getItem('jove-cms-token')) {
    config.headers.Authorization = "Bearer ".concat(sessionStorage.getItem('jove-cms-token'));
  }

  return config;
};
export var getContentDispositionFileName = function getContentDispositionFileName(contentDisposition) {
  if (!contentDisposition) return '';
  var match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);

  if (match && match[1]) {
    return match[1].replace(/['"]/g, '');
  } else {
    return '';
  }
};